// Translation language codes
export const SUPPORTED_LANGUAGES = ['en'];
export const DEFAULT_LANGUAGE = 'en';

// Entity types
export const ENTITY_TYPES = {
  CATEGORY: 'category',
  ITEM: 'item',
  MODIFIER_GROUP: 'modifierGroup',
  INGREDIENT: 'ingredient',
};

// Default translation object
export const DEFAULT_TRANSLATION = {
  en: '',
};

// Form validation rules
export const VALIDATION_RULES = {
  CATEGORY: {
    NAME_MIN_LENGTH: 1,
    NAME_MAX_LENGTH: 100,
    DESCRIPTION_MAX_LENGTH: 500,
  },
  ITEM: {
    NAME_MIN_LENGTH: 1,
    NAME_MAX_LENGTH: 100,
    DESCRIPTION_MAX_LENGTH: 500,
    PRICE_MIN: 0,
    PRICE_MAX: 999999,
  },
  MODIFIER_GROUP: {
    NAME_MIN_LENGTH: 1,
    NAME_MAX_LENGTH: 100,
    MIN_MIN: 0,
    MAX_MIN: 0,
    FREE_MIN: 0,
  },
  INGREDIENT: {
    NAME_MIN_LENGTH: 1,
    NAME_MAX_LENGTH: 100,
  },
};

// Default form values
export const DEFAULT_CATEGORY = {
  name: { en: '' },
  description: { en: '' },
  sort: 0,
  isActive: true,
  scheduleIds: [],
  printerTags: [],
};

export const DEFAULT_ITEM = {
  name: { en: '' },
  title: { en: '' },
  description: { en: '' },
  price: 0,
  priceType: null,
  tax: null,
  sort: 0,
  tags: [],
  isOnePrice: false,
  image: { url: '', fileId: '' },
  soldOut: { status: 'available', soldOutDate: null },
  onItsOwn: false,
  isSizeOption: false,
  kitchenInstruction: { en: '' },
  recipe: { en: '' },
  minAllowedQuantity: null,
  maxAllowedQuantity: null,
  minTotalNumberOfModifierGroups: null,
  maxTotalNumberOfModifierGroups: null,
  minTotalNumberOfModifierItems: null,
  maxTotalNumberOfModifierItems: null,
  isPopular: false,
  scheduleIds: [],
  category: '',
  printerTags: [],
  preselectOptions: {
    defaultSelection: false,
    options: {},
  },
  inOrderViewLayout: null,
  isWeighted: null,
};

export const DEFAULT_MODIFIER_GROUP = {
  name: { en: '' },
  title: { en: '' },
  description: { en: '' },
  min: null,
  max: null,
  free: null,
  isOnePrice: false,
  priceType: null,
  tags: [],
  sort: 0,
  canSelectMultipleOptions: false,
  minAnySingleModifierItems: null,
  maxAnySingleModifierItems: null,
  minTotalNumberOfModifierItems: null,
  maxTotalNumberOfModifierItems: null,
  hideNameOnOrder: false,
  showNestedLayout: 'default',
  inOrderViewLayout: null,
  applyConditionWithMultiplier: null,
  conditionIsAppliedForProduct: null,
  applyValidationToItemsActualQuantity: null,
  sortParentOptionsByThisOptionsSorting: null,
  groupAllParentsByThisOption: null,
  preselectOptions: {
    defaultSelection: false,
    options: {},
  },
};

export const DEFAULT_INGREDIENT = {
  name: { en: '' },
};

// Sold out status enum (matching backend schema)
export const SOLD_OUT_STATUS = {
  AVAILABLE: 'available',
  SOLD_OUT_TODAY: 'soldOutToday',
  SOLD_OUT_PERMANENT: 'soldOutPermanent',
};

// Price type options for items, modifier groups, and options
export const PRICE_TYPE_OPTIONS = [
  { value: '', label: 'None' },
  { value: 'fixPrice', label: 'Fix Price' },
  {
    value: 'multiplierApplyingToNestedPrice',
    label: 'Multiplier (Nested Price)',
  },
  {
    value: 'multiplierApplyingToParentPrice',
    label: 'Multiplier (Parent Price)',
  },
];

// In-order view layout options for items and modifier groups
export const IN_ORDER_VIEW_LAYOUT_OPTIONS = [
  { value: '', label: 'None' },
  { value: 'joinParentFromLeft', label: 'Join Parent From Left' },
  { value: 'joinParentFromRight', label: 'Join Parent From Right' },
];

// Helper to get soldOutDate based on status
export const getSoldOutDate = (status, businessTimezone, moment) => {
  if (status === SOLD_OUT_STATUS.AVAILABLE) {
    return null;
  }
  if (status === SOLD_OUT_STATUS.SOLD_OUT_PERMANENT) {
    return '2039-12-31T20:01:00Z';
  }
  if (status === SOLD_OUT_STATUS.SOLD_OUT_TODAY) {
    const tz = businessTimezone || 'America/Los_Angeles';
    // Get end of day in business timezone and convert to ISO string (UTC)
    const endOfDay = moment().tz(tz).endOf('day');
    return endOfDay.toISOString();
  }
  return null;
};

// Helper functions
export const buildTranslation = (enValue) => ({
  en: enValue,
});

export const getTranslationValue = (translationObj, lang = 'en') => {
  if (!translationObj) return '';
  return translationObj[lang] || translationObj.en || '';
};
